import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import messages from "./messages.i18n";
import { PATHS } from "@constants/Paths";
import { PeekBox, PeekButton, PeekTooltip } from "@piiqtechnologies/ui-components";
import { Plus as PlusIcon } from "@piiqtechnologies/svg-icons";
import { usePolicyContext } from "@piiqtechnologies/ui-lib";
export const AddNewRequestButton = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const scanRequestPolicy = !usePolicyContext("scan_request_create" /* PolicyActions.SCAN_REQUEST_CREATE */);
    const handleNewRequest = () => {
        navigate(`./${PATHS.SCAN_REQUESTS_ADD_NEW_REQUEST}`);
    };
    return (React.createElement(PeekTooltip, { placement: "top", title: scanRequestPolicy && intl.formatMessage(messages.addNewRequestButtonPolicyAlert) },
        React.createElement(PeekBox, null,
            React.createElement(PeekButton, { size: "large", disabled: scanRequestPolicy, variant: "outlined", color: "info", startIcon: React.createElement(PlusIcon, null), onClick: handleNewRequest }, intl.formatMessage(messages.addNewRequestButton)))));
};
export default AddNewRequestButton;
